import { Commission, getCommissions } from '../firebase/financeServices';

/**
 * Subscribes to real-time updates for commission data
 * @param year Year to fetch
 * @param month Month to fetch (0-11)
 * @param staffId Optional staff ID to filter by
 * @param callback Callback function to handle commission data
 * @returns Unsubscribe function
 */
export const subscribeToCommissions = (
  year: number,
  month: number,
  staffId: string | undefined,
  callback: (commissions: Commission[]) => void
): (() => void) => {
  // Set up interval to check for commission updates every 30 seconds
  const intervalId = setInterval(async () => {
    try {
      // Create date range for the selected month
      const startDate = new Date(year, month, 1);
      const endDate = new Date(year, month + 1, 0);
      
      // Get commissions from Firebase
      const commissionsData = await getCommissions(staffId, startDate, endDate);
      
      // Filter to only include commission splits (type='commission' or undefined for backward compatibility)
      const commissionData = commissionsData.filter(comm => comm.type === 'commission' || !comm.type);
      
      callback(commissionData);
    } catch (error) {
      console.error('Error in commission subscription:', error);
    }
  }, 30000); // Check every 30 seconds
  
  // Initial check
  const startDate = new Date(year, month, 1);
  const endDate = new Date(year, month + 1, 0);
  
  getCommissions(staffId, startDate, endDate)
    .then(commissionsData => {
      const commissionData = commissionsData.filter(comm => comm.type === 'commission' || !comm.type);
      callback(commissionData);
    })
    .catch(error => console.error('Error in initial commission check:', error));
  
  // Return unsubscribe function
  return () => {
    clearInterval(intervalId);
  };
};
